const getFullName = (params) => {
  if (params.row) {
    return `${params.row.firstName} ${params.row.lastName}`;
  }

  return `${params.firstName} ${params.lastName}`;
};

export default getFullName;
